import React, { useLayoutEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

export default function Layout({ children }) {
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [showDesktopSidebar, setShowDesktopSidebar] = useState(false);

  const location = useLocation();

  const isEmployeePopup =
    location.pathname.startsWith("/employee-edit/");
  const isGuesthouseBookingEditPopup =
    location.pathname.startsWith("/guesthouse/booking-edit/");

  const noTopMenuRoutes = [
    "/",
    "/login",
    "/about-us",
    "/contact-us",
    "/employee/new"
  ];

  const localUser = (() => {
    try {
      const raw = localStorage.getItem("user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  })();

  const currentModuleId = parseInt(localUser?.moduleId, 10);

  const isGuesthouseAdmin = currentModuleId === 10;

  const hasEmployeeTopMenu =
    Boolean(localUser) &&
    !noTopMenuRoutes.includes(location.pathname);
  const isHomeRoute = location.pathname === "/";

  const [headerOffset, setHeaderOffset] = useState(52);

  useLayoutEffect(() => {
    const getNavEl = () =>
      document.querySelector("nav.custom-header-bg.fixed-top") ||
      document.querySelector("nav.custom-header-home.fixed-top");

    const updateHeaderOffset = () => {
      const fixedHeader = getNavEl();
      if (fixedHeader) {
        setHeaderOffset(Math.ceil(fixedHeader.getBoundingClientRect().height));
      } else {
        setHeaderOffset(hasEmployeeTopMenu ? 72 : 52);
      }
    };

    updateHeaderOffset();

    window.addEventListener("resize", updateHeaderOffset);

    // ResizeObserver catches navbar height changes when buttons wrap to a new row
    const navEl = getNavEl();
    let ro = null;
    if (navEl && typeof ResizeObserver !== "undefined") {
      ro = new ResizeObserver(updateHeaderOffset);
      ro.observe(navEl);
    }

    return () => {
      window.removeEventListener("resize", updateHeaderOffset);
      if (ro) ro.disconnect();
    };
  }, [hasEmployeeTopMenu, location.pathname]);

  if (isEmployeePopup || isGuesthouseBookingEditPopup) {
    return (
      <main className="p-2">
        {children}
      </main>
    );
  }

  return (
    <>
      <Header
        onToggleSidebar={() => {
          setShowMobileSidebar(!showMobileSidebar);
          setShowDesktopSidebar(!showDesktopSidebar);
        }}
      />

      {/* Mobile Sidebar */}
      {showMobileSidebar && !isGuesthouseAdmin && (
        <div
          className="d-lg-none position-fixed start-0 end-0 bg-light border-bottom"
          style={{
            top: `${headerOffset}px`,
            zIndex: 1040
          }}
        >
          <Sidebar />
        </div>
      )}

      <div
        className="d-flex"
        style={{
          marginTop: `${headerOffset}px`,
          minHeight: "80vh"
        }}
      >
        {/* Desktop Sidebar */}
        {!isGuesthouseAdmin &&
          showDesktopSidebar && (
            <div
              className="d-none d-lg-block"
              style={{ width: "220px" }}
            >
              <Sidebar />
            </div>
          )}

        {/* Main Content */}
        <main className={`flex-fill ${isHomeRoute ? "p-0" : "p-3"}`}>
          {children}
        </main>
      </div>

      <Footer />
    </>
  );
}